import { useTranslation } from 'react-i18next'

import { getEnvs } from '../../utils/env'

const { env } = getEnvs()

const EnvBadge = () => {
  const { t } = useTranslation()

  return (
    <>
      <b>{t('Environment')}:</b> {env}
    </>
  )
}

export default EnvBadge
